import type { FaireProductEntity } from "../../entity_types/product";

export const p_gb5jbtna5u: FaireProductEntity = {
  token: "p_gb5jbtna5u",
  type: "product",
  name: "Oasis 500 Aroma Diffuser - House or Commercial Aromatization",
  brandToken: "b_xpcb942eab",
  brandName: "Hello Aromas",
  imageUrl:
    "https://cdn.faire.com/fastly/1c31b1f9744bf436b3544d415547bfb88d5588695dc288c99f2acac976e87bcf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0602cc8e0e0c839b6bf88a6e075b92809d21ef037257e7d05aa7a97c3339f3e.jpeg",
    "https://cdn.faire.com/fastly/b6c2d356bfdae8b80611406e86c4f6343d9cfbc312572112774d1d7e3d507fde.jpeg",
    "https://cdn.faire.com/fastly/ea74deb84bfc15b1f65c6167e23decd10c43027d01a232dd99bb1921a6c4dbf0.jpeg",
    "https://cdn.faire.com/fastly/07e071d304dbd5201964a6788adda2bb57215ac8629b1e3ab3df7b1120e2b083.jpeg",
    "https://cdn.faire.com/fastly/9d03317b6afa134dc4984896f6ee5457f599837a20a30167f1e65a014cedd16a.jpeg",
    "https://cdn.faire.com/fastly/e957728e50d961ec00027346849bcf57afff6039edf91c138d670a8a2eafd8c5.jpeg",
    "https://cdn.faire.com/fastly/23d06551dda48b5e41a0cb3592c795586e9fa043ed9b57427e69f2d48a7bb0c8.jpeg",
    "https://cdn.faire.com/fastly/e40bedbceaa27e4fa6da72856a6f98070024b34cc5717ce7bdbc87363be3d2ba.png",
  ],
  priceDollars: 76.07,
  description:
    "\n * BLUETOOTH CONNECTIVITY: Control your diffuser remotely through a smartphone app, adjusting settings and schedules with ease \n\n * ELEGANT DESIGN: Sleek black housing with premium gold trim accents creates a sophisticated look that complements any decor \n\n * SMART FEATURES: LED indicator light shows operational status while the unit quietly disperses essential oil aromatherapy \n\n * VERSATILE OPERATION: Compatible with all standard essential oils, featuring adjustable mist intensity settings for customized fragrance strength \n\n * COMPACT SIZE: Space-saving design takes up minimal counter space while effectively distributing aroma throughout your room ",
  tags: [],
  msrpDollars: 124.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:10.060Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
